import React, { ReactElement } from 'react';
import {
  Grid,
  GridColumn,
  GridDataStateChangeEvent,
} from '@progress/kendo-react-grid';
import { process, State } from '@progress/kendo-data-query';

import { AssetInfo } from '../../Interfaces/Assets/AssetInfo';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { GetString } from '../StringResourceManager';
import { useEffect } from 'react';
import { LocalizationProvider, loadMessages } from '@progress/kendo-react-intl';
import { locales, LocaleInterface } from '../AlertsGrid/GridLocale';
import esMessages from '../../utils/gridMessageKey.json';
loadMessages(esMessages, 'fr-CA');

interface Props {
  assetInfo: AssetInfo[];
}

const AssetDetailComponent: React.FC<Props> = ({ assetInfo }): ReactElement => {
  const initialDataState: State = { group: [{ field: 'Category' }] };

  const [dataState, setDataState] = React.useState<State>(initialDataState);

  const [currentLocale, setCurrentLocale] = React.useState<LocaleInterface>(
    locales[0]
  );

  const selectedLanguage: string = useSelector(
    (state: ApplicationState) => state.userSettingsReducer.selectedLanguage
  );

  useEffect(() => {
    if (selectedLanguage == 'English') {
      setCurrentLocale(locales[0]);
    } else if (selectedLanguage == 'French') {
      setCurrentLocale(locales[1]);
    }
  }, [selectedLanguage]);

  return (
    <LocalizationProvider language={currentLocale.language}>
      <Grid
        style={{ height: '650px', width: '900px' }}
        sortable={true}
        filterable={true}
        groupable={true}
        pageable={{
          buttonCount: 4,
          pageSizes: [10, 20, 50, 100, 500],
        }}
        take={100}
        data={process(assetInfo, dataState)}
        {...dataState}
        onDataStateChange={(e: GridDataStateChangeEvent) => {
          setDataState(e.dataState);
        }}
      >
        <GridColumn
          field="Category"
          title={GetString('COLUMN_TITLE_LANE_CATEGORY')}
          width="270px"
        />
        <GridColumn
          field="Name"
          title={GetString('COLUMN_TITLE_LANE_NAME')}
          width="280px"
        />
        <GridColumn
          field="Value"
          title={GetString('COLUMN_TITLE_LANE_VALUE')}
          width="300px"
        />
      </Grid>
    </LocalizationProvider>
  );
};

export default AssetDetailComponent;
